<template>
    <Banner />
</template>
<script>
import Banner from '@/components/Banner.vue';

export default {
    name: 'BannerAdd',
    components: {
        Banner
    },
}
</script>
